import type { StoryElement } from '../types';
import { stripHtml } from './html';

export type StorySummarySource = Pick<StoryElement, 'summary' | 'topic_context'>;

export function displaySummaryFor(
  story: Pick<StoryElement, 'summary'>,
  localSummary: string | null = null,
): string {
  if (localSummary !== null) {
    return localSummary;
  }
  return stripHtml(story.summary || '');
}

export function hasTopicContext(story: Pick<StoryElement, 'topic_context'>): boolean {
  return Boolean(story.topic_context && story.topic_context.length > 0);
}

export function hasSummaryContentFor(
  story: StorySummarySource,
  localSummary: string | null = null,
): boolean {
  return Boolean(displaySummaryFor(story, localSummary)) || hasTopicContext(story);
}
